export default __webpack_public_path__ + "static/logo-7c26bf41db9c977094e15877682e547d.png";